import { styled } from 'styled-components';

export const PlanTableContainer = styled.div`
  width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  max-width: 100%;
  position: relative;
`;

export const Th = styled.th`
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f4f4f4;
`;

export const Td = styled.td`
  padding: 10px;
  width: 290px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    padding: 10px 4px;
    width: 100%;
  }
`;

export const Tr = styled.tr`
  max-width: 100%;

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.default[50]};
    border-radius: 12px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  padding: 12px 0;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  gap: 4px;
  color: ${({ theme }) => theme.colors.default[400]};
  font-size: 16px;
  font-style: normal;
  font-weight: 550;
  line-height: 150%;
  text-overflow: ellipsis;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  height: 48px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    font-size: 14px;
  }

  > svg {
    color: ${({ theme }) => theme.colors.primary[400]};
    transition: 0.2s;
    rect {
      fill: currentColor;
    }
  }
`;

export const FeatureName = styled.div`
  color: ${({ theme }) => theme.colors.default[900]};
  font-size: 16px;
  font-style: normal;
  font-weight: 550;
  line-height: 150%; /* 24px */

  ${({ theme }) => theme.breakpoints.sm.query} {
    font-size: 14px;
  }
`;

export const TableHeader = styled.thead`
  color: ${({ theme }) => theme.colors.default[400]};
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 36px */
  letter-spacing: 1.2px;
  text-align: left;
  white-space: nowrap;

  ${({ theme }) => theme.breakpoints.sm.query} {
    position: absolute;
    top: 0;
    transform: translateY(-100%);
  }
`;
